import { queryOptions, useQuery } from '@tanstack/react-query';
import { getCustomerReferences } from '@/services/api/customer-references';

export const CUSTOMER_REFERENCES_QUERY_KEY = ['funds', 'customer-references'] as const;

export const customerReferencesQueryOptions = () =>
  queryOptions({
    queryKey: CUSTOMER_REFERENCES_QUERY_KEY,
    queryFn: getCustomerReferences,
  });

export const useCustomerReferences = () => useQuery(customerReferencesQueryOptions());
